module.exports = __webpack_public_path__ + "static/media/noBalancePlaceHolder.cca00653.svg";